import { render, staticRenderFns } from "./productVoucher.vue?vue&type=template&id=56f5cd62&scoped=true&"
import script from "./productVoucher.vue?vue&type=script&lang=js&"
export * from "./productVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5cd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f5cd62')) {
      api.createRecord('56f5cd62', component.options)
    } else {
      api.reload('56f5cd62', component.options)
    }
    module.hot.accept("./productVoucher.vue?vue&type=template&id=56f5cd62&scoped=true&", function () {
      api.rerender('56f5cd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productVoucher.vue"
export default component.exports